/**
 * Not used atm when starting to use make sure to add the proper typing to window.d.ts for the window variable
 * import "./site/google";
 */

import { defineAsyncComponent } from "vue";
import MainMenu from "./site/Components/MainMenu.vue";
import Messages from "./site/Components/Messages.vue";
import Modal from "./site/Components/Modal.vue";
import Images from "./site/Components/Product/Images.vue";
import Product from "./site/Components/Product/Product.vue";
import ProductTabs from "./site/Components/Product/ProductTabs.vue";
import SearchBar from "./site/Components/Search/SearchBar.vue";

import.meta.glob(["../images/**"]);

import { createPinia } from "pinia";

const pinia = createPinia();

import { createApp } from "vue/dist/vue.esm-bundler.js";
import VariantList from "./site/Components/Product/VariantList.vue";
import { useLabelStore } from "./site/stores/label";

const app = createApp({
    mounted() {
        // flash_session();
    },
    created() {
        const labelStore = useLabelStore();
        labelStore.setFromJsonString(window.labels);
    },
});

app.use(pinia);

app.component("search-bar", SearchBar)
    // .component('cart-overview', CartOverview)
    // .component('cart-header', CartHeader)
    .component("main-menu", MainMenu)
    .component("modal", Modal)
    .component("messages", Messages)
    .component("product", Product)
    .component("product-images", Images)
    .component("product-tabs", ProductTabs)
    .component("variant-list", VariantList)
    // .component('add-to-cart', AddToCart)
    // .component('add-to-cart-detail', AddToCartDetail)
    // .component('after-adding', AfterAdding)
    // Async / lazy load components
    .component(
        "skeleton",
        defineAsyncComponent(() => import("./site/Components/Skeleton.vue")),
    )
    // .component('address-input', defineAsyncComponent(() => import('./site/Components/Address/AddressEntityInput.vue')))
    // .component('address-list', defineAsyncComponent(() => import('./site/Components/Address/AddressList.vue')))
    .component(
        "product-overview",
        defineAsyncComponent(
            () => import("./site/Components/Product/ProductOverview.vue"),
        ),
    )
    .component(
        "contact-form",
        defineAsyncComponent(
            () => import("./site/Components/Form/ContactForm.vue"),
        ),
    )
    .component(
        "newsletter-form",
        defineAsyncComponent(
            () => import("./site/Components/Form/NewsletterForm.vue"),
        ),
    )
    .component(
        "video-wrapper",
        defineAsyncComponent(
            () => import("./site/Components/VideoWrapper.vue"),
        ),
    )
    // .component('cart-status', defineAsyncComponent(() => import('./site/Components/Cart/CartStatus.vue')))
    .component(
        "prevent-interaction",
        defineAsyncComponent(
            () => import("./site/Components/PreventInteraction.vue"),
        ),
    )
    .component(
        "row-slider",
        defineAsyncComponent(() => import("./site/Components/RowSlider.vue")),
    )
    // Carousel
    .component(
        "carousel",
        defineAsyncComponent(() => import("./site/ui/carousel/Carousel.vue")),
    )
    .component(
        "carousel-content",
        defineAsyncComponent(
            () => import("./site/ui/carousel/CarouselContent.vue"),
        ),
    )
    .component(
        "carousel-item",
        defineAsyncComponent(
            () => import("./site/ui/carousel/CarouselItem.vue"),
        ),
    )
    .component(
        "carousel-previous",
        defineAsyncComponent(
            () => import("./site/ui/carousel/CarouselPrevious.vue"),
        ),
    )
    .component(
        "carousel-next",
        defineAsyncComponent(
            () => import("./site/ui/carousel/CarouselNext.vue"),
        ),
    )
    .component(
        "selected-icon",
        defineAsyncComponent(
            () => import("./site/Components/SelectedIcon.vue"),
        ),
    );

app.mount("#app");
